"use client";

import React, { useEffect, useState } from "react";
import BreadCrumb from "@/components/breadcrumb/breadcrumb";
import ErrorWarningLineIcon from "remixicon-react/ErrorWarningLineIcon";
import fetcher from "@/lib/fetcher";
import { CompanyUser } from "@/types/user";
import ContactInfo from "./components/ContactInfo";
import ProfileInfo from "./components/ProfileInfo";
import AccountSettings from "./components/AccountSettings";
import LogoutButton from "./components/LogoutButton";

interface UserResponse {
  status: number;
  data: CompanyUser;
}

const MyAccount = () => {
  const [user, setUser] = useState<CompanyUser | null>(null);

  const fetchUserData = async () => {
    try {
      const res = await fetcher<UserResponse>("company-users/me");
      if (res?.data) {
        setUser(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <div className="bg-[#F8FAFB] min-h-screen pb-10">
      <div className="bg-breadcrumb px-4 md:px-6 border-b border-gray-200">
        <BreadCrumb
          routes={[
            { name: "Home", href: "/" },
            { name: "My Account", href: "/my-account" },
          ]}
        />
      </div>

      <div className="bg-white p-4 mb-8 border-t border-b border-gray-bg2 ">
        <div className="container md:px-6 mx-auto flex justify-between items-center ">
          <h1 className="text-3xl font-bold text-black">My Account</h1>
          <LogoutButton />
        </div>
      </div>

      <div className="container px-4 md:px-6 mx-auto ">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <ContactInfo user={user} />
          </div>

          <div className="lg:col-span-2 space-y-6">
            {!user?.firstName && user?.lastName && user.contactNo ? (
              <div className="bg-[#FEF9EB] border-l-4 border-orange-500 rounded-2xl p-6 flex gap-4 shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="text-[#A15044] mt-1">
                  <ErrorWarningLineIcon size={24} />
                </div>
                <div>
                  <h3 className="text-orange-900 font-bold text-lg">
                    Complete Your Profile
                  </h3>
                  <p className="text-orange-800/80 text-sm mt-1">
                    Please fill in all your details below to enjoy a seamless
                    checkout experience and faster order processing.
                  </p>
                </div>
              </div>
            ) : null}

            <ProfileInfo user={user} onProfileUpdated={fetchUserData} />

            <AccountSettings />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
